import "packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/integration/mcp-server/setting-panel.css.ts.vanilla.css!=!../../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/integration/mcp-server/setting-panel.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA81Z0ZKiOhB99yvycqu0ajMFjLrKvNzaP4kkaHZCwoYouFvz77cIEhIGFFDn7pNTIek-3ek-3el5SU5pIJUH_swAwDRLGTqHIGakeJsB_QsxlSRSVPAQRIIdE15-2aM0BMEyLd5mH7OXSoivheyExESGwE8LkAlGMTghOYcQxTHlBJ4CyNCZSEh5RjH5oXfD6tDizZyHEmF6zEKwSTUScSIyZiIPwYFiTDSGHYre91IcOQ57dDQ7YCppguR5YeENuo1GjO45pIokWQgiwhWR5fLPY6ZofIaR4IpwFYIsRRGBO6JyQhqf-EEFOEUYU76vFoC_rlZ3tblKiWSqj4wBr9qAWHAFM_qbtLxQrSfaqfrvnND9QYVg7XnlWiSYkJ89p0ihury1vK2syLQyVi4cLsoCr7L8mraMRILjlr7VYH1dxo3G0GHxemxS9ESOjotNKyyCTVoYYBqBPt2cMzC-T8rNz3G4dpJ1M06qObd1z-0lxVqnpBgqkqQMKQKrU1kIEsoTVMy9b8CP5QKgoxK3HPWVCbQNGcoUjA6UYYu8jHjP2ov0BpGiiKpzCLyX1Wo0CXUG-k4LTiiHOcXqoLWOv2-XiqNRtyRJSpCaB99a97WwpZtgfQoFdKQfHkDPO5SRUpcBegmTtjfr8gFzWe5C_JwfiCSWNqK1DWUpAPIDVQTqGhACLkq5lrT4SnZVEKoD9uW1URthe1cY5dq7N8pVgopalu95_7gZlRbAzae62l6ATA7qoZfsRJHvV1qdoKkT_vbNHUbeXKVZnRkJAVWI0cgSRkf1BDazf1EZ_mnzVH1t2-22XV7SogPYVU874Ja3wblevZ8H3wfnzKdWTO8hHLt3YiSzKWxY1ioYU2VI0d94aWGI0QhPtPAmt5ZWtXp6t_TogpiMKIh8ildf-2tM7bQEyT3lF-JutS-luzKTvVxwmwjEKEDl46WFpZ3SPXycTuHjTzHbfLqoCC7ka2Jh-fdQ9Ije27jp1__2vFIivTsT5H3obUbqq_ouSWWTqjzlhjte267x6jjujqBHhoE-hEkkJKq60yPHRNadmf5qVqCI44woXaMs-9WkZ8766Y-FR5S244NToS-ifNelJ1ftjono3R2m1A8y47_yVep7nWGznkA8dhyNircYJZSduyIuEVxcPg8Oz84ae72Dz7XvLtS88ry6NpmuOkIsmvued8oB1Lm3mPJs89sBXKEzMIr2FMTfdHRr01rJ87TBgjtH-H1P2g65u9GDI3_iMLN1EVcyYfNFJbgxqRqttpm-B9adA1irfhj7n5vzjZ1Bq5m-bujf0AI12F8fEnaly59ld4N1-DB3fPqtHjx7qjziso4_ejZrO3vwdOjrhl1-z5R3eoswaRzR4Knmw2W9M3OCjdf-X0zdPvQ82Z6VvU_oEJxmIJUE1n1VLiSGO0nQewj0D0SM2Y7adl_c4BnFvwnBFIEskoRwgDgGc6vL-F52Hgutwnl29-aTH-sA-WgO_LoccEJJo8kUkupNf-xPHEuSvEjqts1I-5h9_Af324jmVxwAAA\"}!../../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var agentGuideStep = 'mvp2rto';
export var agentGuideStepNumber = 'mvp2rtp';
export var agentGuideSteps = 'mvp2rtn';
export var agentSkill = 'mvp2rtq';
export var agentSkillActions = 'mvp2rtr';
export var capabilities = 'mvp2rtl';
export var capability = 'mvp2rtm';
export var codeHeader = 'mvp2rt17';
export var description = 'mvp2rt4';
export var empty = 'mvp2rt6';
export var endpoint = 'mvp2rtv';
export var endpointBlock = 'mvp2rtt';
export var endpointHeader = 'mvp2rtu';
export var field = 'mvp2rtz';
export var fixedValue = 'mvp2rt10';
export var form = 'mvp2rty';
export var label = 'mvp2rt5';
export var metadataGrid = 'mvp2rtc';
export var metadataItem = 'mvp2rtd';
export var metadataLabel = 'mvp2rte';
export var modal = 'mvp2rtw';
export var modalActions = 'mvp2rt19';
export var modalTitle = 'mvp2rtx';
export var panel = 'mvp2rt1';
export var panelHeader = 'mvp2rt2';
export var preArea = 'mvp2rt18';
export var row = 'mvp2rt9';
export var rowActions = 'mvp2rtk';
export var rowDisabled = 'mvp2rta';
export var rowMain = 'mvp2rtb';
export var rowTitle = 'mvp2rti';
export var rows = 'mvp2rt8';
export var scopeList = 'mvp2rtf';
export var scopeNotice = 'mvp2rt13';
export var scopeTag = 'mvp2rtg';
export var select = 'mvp2rt11';
export var skeletons = 'mvp2rt7';
export var skillLink = 'mvp2rts';
export var stack = 'mvp2rt0';
export var summary = 'mvp2rt14';
export var summaryGrid = 'mvp2rt15';
export var summaryItem = 'mvp2rt16';
export var tag = 'mvp2rtj';
export var title = 'mvp2rt3';
export var unsupportedScope = 'mvp2rth';
export var warning = 'mvp2rt12';